import { render } from "./CompararArchivoModal.vue?vue&type=template&id=2157878e&scoped=true"
import script from "./CompararArchivoModal.vue?vue&type=script&lang=js"
export * from "./CompararArchivoModal.vue?vue&type=script&lang=js"

import "./CompararArchivoModal.vue?vue&type=style&index=0&id=2157878e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2157878e"]])

export default __exports__